import { pushDataLayer } from './tracking';

const THRESHOLDS = [25, 50, 75, 100];

/**
 * Emit a `scroll_depth` dataLayer event the first time the visitor reaches each
 * of 25/50/75/100% of the page, so Matomo can report how far people read.
 * Self-initialising; the listener detaches once 100% has been reported.
 */
export const initScrollDepth = () => {
  if (typeof window === 'undefined') return;

  const reached = new Set<number>();

  const check = () => {
    const doc = document.documentElement;
    const scrollable = doc.scrollHeight - window.innerHeight;
    // Pages with nothing to scroll count as fully read.
    const percent =
      scrollable <= 0
        ? 100
        : Math.min(100, Math.round((window.scrollY / scrollable) * 100));

    for (const threshold of THRESHOLDS) {
      if (percent >= threshold && !reached.has(threshold)) {
        reached.add(threshold);
        pushDataLayer({ event: 'scroll_depth', scroll_percent: threshold });
      }
    }

    if (reached.size === THRESHOLDS.length) {
      window.removeEventListener('scroll', onScroll);
    }
  };

  let ticking = false;
  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      check();
      ticking = false;
    });
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  check(); // capture short pages / a restored scroll position immediately
};
